export default "__VITE_ASSET__Cc35a647__"